<template>
  <div id="subbar">
    <div class="container">
      <div></div> <!-- to make sure its flex -->
      <div class="is-flex is-align-items-center">
        <router-link to="/premium" class="mr-5">
          <b-tag v-if="!hasPremium" type="is-primary" size="is-small">Premium: Probeer gratis</b-tag>
          <b-tag v-else type="is-default" size="is-small">{{ premiumType | ucfirst }} abonnement</b-tag>
        </router-link>
        <router-link to="/settings">
          <b-icon class="settings-page mr-5 color-dark" icon="cog" />
        </router-link>
        <b-dropdown position="is-bottom-left" aria-role="list">
          <template #trigger="{ active }">
            <div class="profile-icon hoverable" :class="{ 'is-active': active }">
              <b-icon icon="account" />
            </div>
          </template>
          <b-dropdown-item @click="profile()" aria-role="listitem"><b-icon icon="account" size="is-small" /> {{ username | ucfirst }}</b-dropdown-item>
          <b-dropdown-item @click="logout()" aria-role="listitem"><b-icon icon="logout" size="is-small" /> Uitloggen</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  methods: {
    changeDarkmode() {
      this.$store.commit(`app/${TOGGLE_DARKMODE}`)
    },
    profile() {
      this.$router.push("/profile/" + this.username)
    },
    async logout() {
      await this.$store.dispatch(`user/logout`)
      this.$router.push("/unauthorized")
    },
  },
  computed: {
    darkMode() {
      return this.$store.state.app.darkMode
    },
    ...mapState("user", ["username", "hasPremium", "premiumType"]),
  },
}
</script>
<style lang="scss" scoped>
#subbar {
  position: relative;
  z-index: 1;
  width: auto;
  height: 60px;
  .container {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .profile-icon {
      display: flex;
      background-color: #fff;
      border-radius: 50px;
      width: 30px;
      height: 30px;
      align-items: center;
      justify-content: center;
      &.is-active {
        background-color: #1d73f4;
        color: #fff;
      }
    }
    .router-link-exact-active .settings-page {
      color: #1d73f4 !important;
    }
  }
  .field {
    margin-bottom: 0 !important;
    margin-left: 5px;
    margin-right: 5px;
  }
}
</style>
